import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import "./styles/tokens.css";
import "./index.css";
import App from "./App";
import "./styles/main.scss";

import reportWebVitals from "./reportWebVitals";
import { installTimezoneHeader } from "./utils/timezoneHeader";
import { installVersionCheck } from "./utils/versionCheck";
import { captureRef } from "./utils/referralCapture";

installTimezoneHeader();
installVersionCheck();
// Invite links: keep ?ref=CODE for sign-up.
captureRef();

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN || "",
  environment: process.env.NODE_ENV,
  enabled: process.env.NODE_ENV === "production",
  tracesSampleRate: 0.1, // 10% performance sampling
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0,
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
